import { BrowserModule } from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import {AppRoutingModule} from './app-routing.module';
import {APP_BASE_HREF} from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { HomeContentComponent } from './home/home-content/home-content.component';
import { FooterComponent } from './footer/footer.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatDividerModule} from '@angular/material/divider';
import { LoginComponent } from './login/login.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import {CookieService} from 'ngx-cookie-service';
import {TranslateLoader, TranslateModule, TranslateService} from '@ngx-translate/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { PartnersComponent } from './partners/partners.component';
import { PartnersContentComponent } from './partners/partners-content/partners-content.component';
import { StoreComponent } from './store/store.component';
import { StoreContentComponent } from './store/store-content/store-content.component';
import {LastVersionPipe} from './LastVersionPipe';
import { FloatingDivComponent } from './html-elements/floating-div/floating-div.component';
import {StoreResolver} from './store/store.resolver';
import { AffiliateProgramComponent } from './affiliate-program/affiliate-program.component';
import { AffiliateProgramContentComponent } from './affiliate-program/affiliate-program-content/affiliate-program-content.component';
import { ContactsComponent } from './contacts/contacts.component';
import { ContactsContentComponent } from './contacts/contacts-content/contacts-content.component';
import { AboutUsComponent } from './about-us/about-us.component';
import { AboutUsContentComponent } from './about-us/about-us-content/about-us-content.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import {NgbDropdown, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {SidebarComponent} from './admin-ui/shared/sidebar/sidebar.component';
import {BreadcrumbComponent} from './admin-ui/shared/breadcrumb/breadcrumb.component';
import {NavigationComponent} from './admin-ui/shared/header-navigation/navigation.component';
import {FullComponent} from './admin-ui/layouts/full/full.component';
import {SpinnerComponent} from './admin-ui/shared/spinner.component';
import { AdminTestComponent } from './admin-test/admin-test.component';
import {VpsResolver} from './admin-ui/vps.resolver';
import {UserResolver} from './admin-ui/user.resolver';
import {SoftwaresResolver} from './admin-ui/softwares.resolver';
import {LoginResolver} from './login/login.resolver';
import { VpsManagerComponent } from './admin-ui/sections/vps-manager/vps-manager.component';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { PaymentsComponent } from './admin-ui/sections/payments/payments.component';
import { GetStartedComponent } from './get-started/get-started.component';
import { GetStartedContentComponent } from './get-started/get-started-content/get-started-content.component';
import { ActivationHandlerComponent } from './activation-handler/activation-handler.component';
import { PartnerManagerComponent } from './partner-manager/partner-manager.component';
import {PartnerUsersResolver} from './partner-manager/partner-users.resolver';
import {RequestActivationResolver} from './partner-manager/request-activation.resolver';
import {PartnerResolver} from './partner-manager/partner.resolver';
import { CreateSoftwareDialogComponent } from './partner-manager/create-software-dialog/create-software-dialog.component';
import {MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule} from '@angular/material/dialog';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatChipsModule} from '@angular/material/chips';
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {ClipboardModule} from '@angular/cdk/clipboard';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatGridListModule} from '@angular/material/grid-list';
import { AdminManagerComponent } from './admin-manager/admin-manager.component';
import {AdminSoftwaresResolver} from './admin-manager/admin-softwares.resolver';
import {VpsAdminResolver} from './admin-manager/vps-admin.resolver';
import {AdminResolver} from './admin-manager/admin.resolver';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { BillingPeriodPipe } from './billing-period.pipe';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    HeaderComponent,
    HomeContentComponent,
    FooterComponent,
    LoginComponent,
    PartnersComponent,
    PartnersContentComponent,
    StoreComponent,
    StoreContentComponent,
    LastVersionPipe,
    FloatingDivComponent,
    AffiliateProgramComponent,
    AffiliateProgramContentComponent,
    ContactsComponent,
    ContactsContentComponent,
    AboutUsComponent,
    AboutUsContentComponent,
    SignInComponent,
    ResetPasswordComponent,
    SpinnerComponent,
    FullComponent,
    NavigationComponent,
    BreadcrumbComponent,
    SidebarComponent,
    AdminTestComponent,
    VpsManagerComponent,
    PaymentsComponent,
    GetStartedComponent,
    GetStartedContentComponent,
    ActivationHandlerComponent,
    PartnerManagerComponent,
    CreateSoftwareDialogComponent,
    AdminManagerComponent,
    LoginAdminComponent,
    BillingPeriodPipe
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    MatDividerModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatCheckboxModule,
    MatDialogModule,
    MatExpansionModule,
    MatChipsModule,
    MatOptionModule,
    MatSelectModule,
    ClipboardModule,
    MatTableModule,
    MatPaginatorModule,
    MatGridListModule,
    MatListModule
  ],
  providers: [
    StoreResolver, VpsResolver, UserResolver, SoftwaresResolver,LoginResolver, NgbDropdown, PartnerUsersResolver, RequestActivationResolver,PartnerResolver,
    AdminSoftwaresResolver, VpsAdminResolver,AdminResolver,
    {provide: APP_BASE_HREF, useValue: '/'}, CookieService, {provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: {hasBackdrop: false}}],
  exports: [
    HeaderComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
